"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPublicDataValueProvider = buildPublicDataValueProvider;
const PublicDataClient_1 = require("@juvare/platform-sdk-js/PublicDataClient");
function buildPublicDataValueProvider({ appName, baseUrl, classifierName, label, }) {
    const client = new PublicDataClient_1.PublicDataClient(appName ?? window.appName, baseUrl);
    return {
        type: 'classifier.' + classifierName,
        label: label,
        getValues: () => client.publicDataGetObject('classifier-' + classifierName),
    };
}
